import "date-fns";
import React from "react";
import Button from "@material-ui/core/Button";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

function ShipmentDate({ ...props }) {
  const handleDateChange = (date) => {
    props.handleChange("shipmentready", date);
  };
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">
            What is your estimated shipment ready date?
          </p>
        </div>
        <div className="ContainerVertical MarginHorizontal NoPadding">
          <KeyboardDatePicker
            style={{
              background: "rgba(255, 255, 255, 0.8)",
              width: "96%",
              borderRadius: "3px",
              padding: "12px",
            }}
            margin="normal"
            id="date-picker-dialog"
            label=""
            format="yyyy/MM/dd"
            value={props.order.shipmentready}
            onChange={handleDateChange}
            autoOk={true}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => props.handleBack()}
          className="TransparentWhite Medium"
        >
          Back
        </Button>
        <div className="ButtonContainer">
          <Button
            onClick={() => props.handleNext()}
            className="TransparentWhite Medium"
          >
            Skip
          </Button>
          <Button onClick={() => props.handleNext()} className="OldLace Medium">
            Next
          </Button>
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default ShipmentDate;
